<template>
    <div>
        <label class="radio-container" v-for="(service,index) in requestedServices" v-bind:key="index">
            {{service.Name}}
            <input type="checkbox" :checked="service.Selected" v-model="service.Selected">
            <span class="checkmark"></span>
            <div v-if="service.Selected" class="illness-warning">{{service.Warning}}</div>
            <label class="radio-container" v-if="service.Selected" v-for="(subServices,counter) in service.SubServices" v-bind:key="counter">
                {{subServices.Name}}
                <input type="checkbox" :checked="subServices.Selected" v-model="subServices.Selected">
                <span class="checkmark"></span>
            </label>
        </label>
    </div>
</template>
<script>
export default {
    name: "RequestedServices",
    props: ['requestedServices']
}
</script>



// WEBPACK FOOTER //
// src/components/PetRequestedServiceList.vue